/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePlaceDto } from '../../models/create-place-dto';
import { PlaceDto } from '../../models/place-dto';

export interface PlaceControllerCreate$Params {
      body: CreatePlaceDto
}

export function placeControllerCreate(http: HttpClient, rootUrl: string, params: PlaceControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlaceDto>> {
  const rb = new RequestBuilder(rootUrl, placeControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlaceDto>;
    })
  );
}

placeControllerCreate.PATH = '/api/places';
